import React from "react";
import { BrowserRouter as Router, Routes, Route, Link, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Welcome from "./pages/Welcome";
import ThankYou from "./pages/ThankYou";
import Home from "./pages/Home";
import Greetings from "./pages/Greetings";
import Replies from "./pages/Replies";
import Login from "./pages/Login";
import Register from "./pages/Register";

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <div className="loading">Loading...</div>;
  }
  
  return isAuthenticated ? children : <Navigate to="/login" />;
}

function Navigation() {
  const { isAuthenticated, user, logout } = useAuth();
  const location = useLocation();
  
  // Hide navbar on public pages (welcome and thank-you)
  const isPublicPage = location.pathname === '/' || location.pathname === '/thank-you';
  
  if (isPublicPage && !isAuthenticated) {
    return null; // No navbar on public pages
  }

  return (
    <nav className="navbar">
      <div className="nav-brand">Hermes Echo</div>
      <div className="nav-links">
        {isAuthenticated ? (
          <>
            <Link to="/admin">🏠 Dashboard</Link>
            <Link to="/greetings">💬 Greetings</Link>
            <Link to="/replies">📨 Replies</Link>
            <span className="user-info">👤 {user?.name}</span>
            <button onClick={logout} className="logout-btn">Logout</button>
          </>
        ) : null}
      </div>
    </nav>
  );
}

function AppContent() {
  return (
    <div className="App">
      <Navigation />
      <div className="content">
        <Routes>
          {/* Public customer-facing routes */}
          <Route path="/" element={<Welcome />} />
          <Route path="/thank-you" element={<ThankYou />} />
          
          {/* Auth routes (URL-only, no navigation links) */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          
          {/* Protected admin routes */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/greetings"
            element={
              <ProtectedRoute>
                <Greetings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/replies"
            element={
              <ProtectedRoute>
                <Replies />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
